<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper p-0">
     <!-- MOBILE VIEW (Aesthetic Modern) -->
     <div class="content d-lg-none mob-add-member p-0">
        <!-- Modern Header -->
        <div class="mob-sticky-header-form bg-white shadow-xs px-3 py-3 d-flex align-items-center gap-3">
           <a href="javascript:void(0);" @click="router.push('/people/kios-list')" class="btn-back-mob shadow-sm">
              <vue-feather type="arrow-left" size="20"></vue-feather>
           </a>
           <h5 class="fw-800 mb-0 text-dark">Daftar Kios Baru</h5>
        </div>

        <div class="px-3 pt-4 pb-5 mb-5">
           <!-- Section: Info Dasar -->
           <div class="mob-form-card bg-white shadow-xs rounded-4 p-4 mb-4">
              <div class="d-flex align-items-center gap-2 mb-4">
                 <div class="section-icon bg-success-soft text-success">
                    <vue-feather type="info" size="16"></vue-feather>
                 </div>
                 <h6 class="fw-800 mb-0 text-dark uppercase tracking-wider">Informasi Kios</h6>
              </div>

              <div class="mb-3">
                 <label class="mob-label">Nama Pemilik <span class="text-danger">*</span></label>
                 <input type="text" v-model="formData.nama_member" class="mob-input" placeholder="Masukkan nama pemilik" required>
              </div>
              <div class="mb-3">
                 <label class="mob-label">Nama Toko / Kios <span class="text-danger">*</span></label>
                 <input type="text" v-model="formData.nama_toko" class="mob-input" placeholder="Masukkan nama toko" required>
              </div>
              <div class="mb-3">
                 <label class="mob-label">Nomor WhatsApp</label>
                 <input type="tel" v-model="formData.nomor_handphone" class="mob-input" placeholder="Contoh: 0812...">
              </div>
              <div class="mb-4">
                 <label class="mob-label">Petugas Pendamping</label>
                 <vue-select
                   :options="pendampingOptions"
                   v-model="formData.pendamping_id"
                   placeholder="Pilih Petugas..."
                   @select="formData.pendamping_id = $event.id"
                   class="mob-select"
                 />
              </div>
              <div class="mb-0">
                 <label class="mob-label">Alamat Lengkap</label>
                 <textarea v-model="formData.alamat" class="mob-input" rows="3" placeholder="Tulis alamat lengkap..."></textarea>
              </div>
           </div>

           <!-- Section: Lokasi Maps -->
           <div class="mob-form-card bg-white shadow-xs rounded-4 p-4 mb-4">
              <div class="d-flex align-items-center gap-2 mb-4">
                 <div class="section-icon bg-blue-soft text-blue">
                    <vue-feather type="map-pin" size="16"></vue-feather>
                 </div>
                 <h6 class="fw-800 mb-0 text-dark uppercase tracking-wider">Lokasi Kios</h6>
              </div>

              <div class="mb-3">
                 <label class="mob-label">Salin Koordinat Google Maps</label>
                 <div class="position-relative">
                    <input 
                       type="text" 
                       v-model="formData.koordinat" 
                       class="mob-input ps-5" 
                       placeholder="Tempel koordinat di sini..."
                       @input="handleCoordinatePaste"
                    >
                    <vue-feather type="crosshair" size="16" class="mob-input-icon text-muted"></vue-feather>
                 </div>
              </div>
              <div class="row g-2">
                 <div class="col-6">
                    <label class="smallest fw-bold text-muted uppercase">Latitude</label>
                    <input type="text" v-model="formData.latitude" class="mob-input bg-light-soft border-0" readonly placeholder="-">
                 </div>
                 <div class="col-6">
                    <label class="smallest fw-bold text-muted uppercase">Longitude</label>
                    <input type="text" v-model="formData.longitude" class="mob-input bg-light-soft border-0" readonly placeholder="-">
                 </div>
              </div>
           </div>

           <!-- Section: Berkas & Foto -->
           <div class="mob-form-card bg-white shadow-xs rounded-4 p-4 mb-4">
              <div class="d-flex align-items-center gap-2 mb-4">
                 <div class="section-icon bg-purple-soft text-purple">
                    <vue-feather type="image" size="16"></vue-feather>
                 </div>
                 <h6 class="fw-800 mb-0 text-dark uppercase tracking-wider">Galeri Berkas</h6>
              </div>

              <div class="row g-3">
                 <!-- Foto Profil -->
                 <div class="col-6">
                    <label class="mob-label">Foto Pemilik</label>
                    <div class="mob-upload-box" @click="triggerFileInput('foto_profil')">
                       <img v-if="previews.foto_profil" :src="previews.foto_profil" class="preview-full">
                       <div v-else class="upload-placeholder">
                          <vue-feather type="user" size="24" class="text-muted"></vue-feather>
                       </div>
                       <button v-if="previews.foto_profil" class="mob-btn-remove" @click.stop="removeImage('foto_profil')">
                          <vue-feather type="x" size="12"></vue-feather>
                       </button>
                    </div>
                 </div>

                 <!-- Foto Toko -->
                 <div class="col-6">
                    <label class="mob-label">Foto Toko</label>
                    <div class="mob-upload-box" @click="triggerFileInput('foto_toko')">
                       <img v-if="previews.foto_toko" :src="previews.foto_toko" class="preview-full">
                       <div v-else class="upload-placeholder">
                          <vue-feather type="home" size="24" class="text-muted"></vue-feather>
                       </div>
                       <button v-if="previews.foto_toko" class="mob-btn-remove" @click.stop="removeImage('foto_toko')">
                          <vue-feather type="x" size="12"></vue-feather>
                       </button>
                    </div>
                 </div>

                 <!-- Foto KTP -->
                 <div class="col-6">
                    <label class="mob-label">Scan KTP</label>
                    <div class="mob-upload-box" @click="triggerFileInput('foto_ktp')">
                       <img v-if="previews.foto_ktp" :src="previews.foto_ktp" class="preview-full">
                       <div v-else class="upload-placeholder">
                          <vue-feather type="credit-card" size="24" class="text-muted"></vue-feather>
                       </div>
                       <button v-if="previews.foto_ktp" class="mob-btn-remove" @click.stop="removeImage('foto_ktp')">
                          <vue-feather type="x" size="12"></vue-feather>
                       </button>
                    </div>
                 </div>

                 <!-- QR Code -->
                 <div class="col-6">
                    <label class="mob-label">Scan QR</label>
                    <div class="mob-upload-box border-success-soft" :class="{'scanning-active': isScanning}" @click="triggerFileInput('qr_code')">
                       <img v-if="previews.qr_code" :src="previews.qr_code" class="preview-full">
                       <div v-else class="upload-placeholder">
                          <vue-feather type="grid" size="24" class="text-muted" :class="{'mob-pulse': isScanning}"></vue-feather>
                       </div>
                       <button v-if="previews.qr_code" class="mob-btn-remove" @click.stop="removeImage('qr_code')">
                          <vue-feather type="x" size="12"></vue-feather>
                       </button>
                    </div>
                 </div>

                 <!-- Logo Toko (Wide) -->
                 <div class="col-12">
                    <label class="mob-label">Logo Toko (Opsional)</label>
                    <div class="mob-upload-box-wide" @click="triggerFileInput('logo_toko')">
                       <img v-if="previews.logo_toko" :src="previews.logo_toko" class="preview-full object-fit-contain p-2">
                       <div v-else class="upload-placeholder-wide">
                          <vue-feather type="star" size="20" class="text-muted mb-1"></vue-feather>
                          <span class="smallest fw-bold text-muted">UPLOAD LOGO</span>
                       </div>
                       <button v-if="previews.logo_toko" class="mob-btn-remove" @click.stop="removeImage('logo_toko')">
                          <vue-feather type="x" size="12"></vue-feather>
                       </button>
                    </div>
                 </div>
              </div>

              <!-- Barcode Field -->
              <div class="mt-4 pt-2 border-top">
                 <label class="mob-label">Kode Barcode Terpilih <span class="text-danger">*</span></label>
                 <div class="bg-light-soft rounded-3 p-3 text-center border-dashed">
                    <h5 class="fw-800 mb-0" :class="formData.kode_barcode ? 'text-success' : 'text-muted'" style="letter-spacing: 2px;">
                       {{ formData.kode_barcode || 'BELUM TERPINDAI' }}
                    </h5>
                    <small v-if="formData.kode_barcode" class="text-success smallest uppercase fw-bold">SIAP DISIMPAN</small>
                 </div>
                 <input type="hidden" v-model="formData.kode_barcode" required>
              </div>
           </div>
        </div>

        <!-- Sticky Footer Action -->
        <div class="mob-sticky-footer bg-white border-top p-3 shadow-lg">
           <button 
            v-if="$hasPermission('ssp', 'members', 'create')"
            @click="submitForm" 
            class="btn btn-success w-100 rounded-pill py-3 fw-800 shadow-sm d-flex align-items-center justify-content-center gap-2" 
            :disabled="isSubmitting"
           >
              <vue-feather v-if="!isSubmitting" type="save" size="18"></vue-feather>
              <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
              {{ isSubmitting ? 'MENYIMPAN...' : 'SIMPAN DATA KIOS' }}
           </button>
           <div v-else class="text-center p-2 text-danger small fw-bold">
              Anda tidak memiliki izin untuk menambah kios baru.
           </div>
        </div>

        <!-- Hidden Inputs for logic -->
        <input type="file" :ref="el => refs.foto_profil = el" @change="handleFileSelect($event, 'foto_profil')" accept="image/*" style="display: none;">
        <input type="file" :ref="el => refs.foto_toko = el" @change="handleFileSelect($event, 'foto_toko')" accept="image/*" style="display: none;">
        <input type="file" :ref="el => refs.logo_toko = el" @change="handleFileSelect($event, 'logo_toko')" accept="image/*" style="display: none;">
        <input type="file" :ref="el => refs.foto_ktp = el" @change="handleFileSelect($event, 'foto_ktp')" accept="image/*" style="display: none;">
        <input type="file" :ref="el => refs.qr_code = el" @change="handleFileSelect($event, 'qr_code')" accept="image/*" style="display: none;">
     </div>

     <!-- DESKTOP VIEW (Existing Aesthetic Version) -->
     <div class="content d-none d-lg-block">
       <!-- Page Header -->
       <div class="page-header">
         <div class="add-item d-flex">
           <div class="page-title">
             <h4>Tambah Kios SSP</h4>
             <h6>Formulir Pendaftaran Member Baru</h6>
           </div>
         </div>
         <div class="page-btn">
           <router-link to="/people/kios-list" class="btn btn-outline-secondary">
             <vue-feather type="chevron-left" class="me-2" style="width: 18px;"></vue-feather>Kembali
           </router-link>
         </div>
       </div>

       <!-- Form Content -->
       <form @submit.prevent="submitForm">
         <div class="row">
           <!-- Left Column -->
           <div class="col-lg-8">
             <!-- Informasi Dasar -->
             <div class="card border-0 shadow-sm mb-3">
               <div class="card-body">
                 <h6 class="fw-bold mb-3 text-dark">Informasi Dasar</h6>
                 <div class="row">
                   <div class="col-md-6 mb-3">
                     <label class="form-label small text-muted">Nama Pemilik <span class="text-danger">*</span></label>
                     <input type="text" v-model="formData.nama_member" class="form-control form-control-sm" placeholder="ABDUL MURTHOLID" required>
                   </div>
                   <div class="col-md-6 mb-3">
                     <label class="form-label small text-muted">Nama Toko <span class="text-danger">*</span></label>
                     <input type="text" v-model="formData.nama_toko" class="form-control form-control-sm" placeholder="MUJAHIDIN 8" required>
                   </div>
                   <div class="col-md-6 mb-3">
                     <label class="form-label small text-muted">Nomor HP/WhatsApp</label>
                     <input type="tel" v-model="formData.nomor_handphone" class="form-control form-control-sm" placeholder="081234567890">
                   </div>
                   <div class="col-md-6 mb-3">
                     <label class="form-label small text-muted">Pendamping</label>
                     <vue-select
                       :options="pendampingOptions"
                       v-model="formData.pendamping_id"
                       placeholder="Pilih Pendamping..."
                       @select="formData.pendamping_id = $event.id"
                     />
                   </div>
                   <div class="col-12 mb-0">
                     <label class="form-label small text-muted">Alamat Lengkap</label>
                     <textarea v-model="formData.alamat" class="form-control form-control-sm" rows="2" placeholder="Dsn. Kebaman, Rt 001/001, Kel. Kebaman, Kec. Srono, Kab. Banyuwangi"></textarea>
                   </div>
                 </div>
               </div>
             </div>

             <!-- Koordinat -->
             <div class="card border-0 shadow-sm mb-3">
               <div class="card-body">
                 <h6 class="fw-bold mb-3 text-dark">Koordinat Lokasi</h6>
                 <div class="row">
                   <div class="col-12 mb-3">
                     <label class="form-label small text-muted">Paste Koordinat dari Google Maps</label>
                     <input 
                       type="text" 
                       v-model="formData.koordinat" 
                       class="form-control form-control-sm" 
                       placeholder="Paste: -8.509153, 114.221324"
                       @input="handleCoordinatePaste"
                     >
                   </div>
                   <div class="col-md-6 mb-3">
                     <label class="form-label small text-muted">Latitude</label>
                     <input type="text" v-model="formData.latitude" class="form-control form-control-sm bg-light" readonly placeholder="Auto dari paste">
                   </div>
                   <div class="col-md-6 mb-3">
                     <label class="form-label small text-muted">Longitude</label>
                     <input type="text" v-model="formData.longitude" class="form-control form-control-sm bg-light" readonly placeholder="Auto dari paste">
                   </div>
                   <div class="col-12">
                     <small class="text-muted">
                       <vue-feather type="info" style="width: 12px;" class="me-1"></vue-feather>
                       Salin dari <a href="https://www.google.com/maps" target="_blank">Google Maps</a>
                     </small>
                   </div>
                 </div>
               </div>
             </div>

            <!-- Submit Actions (Moved here to be aligned with form) -->
            <div class="card border-0 shadow-sm mb-3">
              <div class="card-body d-flex justify-content-between align-items-center">
                <button type="button" class="btn btn-outline-secondary" @click="resetForm">
                  <vue-feather type="rotate-ccw" class="me-2" style="width: 18px;"></vue-feather>
                  Reset Form
                </button>
                <button 
                  v-if="$hasPermission('ssp', 'members', 'create')"
                  type="submit" 
                  class="btn btn-success px-5" 
                  :disabled="isSubmitting"
                >
                  <vue-feather type="save" class="me-2" style="width: 18px;"></vue-feather>
                  {{ isSubmitting ? 'Menyimpan...' : 'Simpan Kios' }}
                </button>
              </div>
            </div>
          </div>

           <!-- Right Column (Upload Photos) -->
           <div class="col-lg-4">
             <!-- Upload Gambar -->
             <div class="card border-0 shadow-sm mb-3">
               <div class="card-body">
                 <h6 class="fw-bold mb-3 text-dark">Upload Foto</h6>
                 
                 <!-- Foto Profil -->
                 <div class="mb-3">
                   <label class="form-label small text-muted mb-1">Foto Profil Pemilik</label>
                   <div 
                     class="dropzone-compact" 
                     @click="triggerFileInput('foto_profil')"
                     @dragover.prevent
                     @drop.prevent="handleDrop($event, 'foto_profil')"
                   >
                     <div v-if="previews.foto_profil" class="preview-img">
                       <img :src="previews.foto_profil" alt="Preview">
                       <button type="button" class="btn-remove" @click.stop="removeImage('foto_profil')">
                         <vue-feather type="x" style="width: 12px;"></vue-feather>
                       </button>
                     </div>
                     <div v-else class="dropzone-empty">
                       <vue-feather type="user" class="text-muted" style="width: 24px;"></vue-feather>
                       <small class="text-muted mt-1">Klik atau Drag & Drop</small>
                     </div>
                   </div>
                   <input type="file" :ref="el => refs.foto_profil = el" @change="handleFileSelect($event, 'foto_profil')" accept="image/*" style="display: none;">
                 </div>

                 <!-- Foto Toko -->
                 <div class="mb-3">
                   <label class="form-label small text-muted mb-1">Foto Toko</label>
                   <div 
                     class="dropzone-compact" 
                     @click="triggerFileInput('foto_toko')"
                     @dragover.prevent
                     @drop.prevent="handleDrop($event, 'foto_toko')"
                   >
                     <div v-if="previews.foto_toko" class="preview-img">
                       <img :src="previews.foto_toko" alt="Preview">
                       <button type="button" class="btn-remove" @click.stop="removeImage('foto_toko')">
                         <vue-feather type="x" style="width: 12px;"></vue-feather>
                       </button>
                     </div>
                     <div v-else class="dropzone-empty">
                       <vue-feather type="home" class="text-muted" style="width: 24px;"></vue-feather>
                       <small class="text-muted mt-1">Klik atau Drag & Drop</small>
                     </div>
                   </div>
                   <input type="file" :ref="el => refs.foto_toko = el" @change="handleFileSelect($event, 'foto_toko')" accept="image/*" style="display: none;">
                 </div>

                 <!-- Logo Toko -->
                 <div class="mb-3">
                   <label class="form-label small text-muted mb-1">Logo Toko (Opsional)</label>
                   <div 
                     class="dropzone-compact" 
                     @click="triggerFileInput('logo_toko')"
                     @dragover.prevent
                     @drop.prevent="handleDrop($event, 'logo_toko')"
                   >
                     <div v-if="previews.logo_toko" class="preview-img">
                       <img :src="previews.logo_toko" alt="Preview">
                       <button type="button" class="btn-remove" @click.stop="removeImage('logo_toko')">
                         <vue-feather type="x" style="width: 12px;"></vue-feather>
                       </button>
                     </div>
                     <div v-else class="dropzone-empty">
                       <vue-feather type="star" class="text-muted" style="width: 24px;"></vue-feather>
                       <small class="text-muted mt-1">Klik atau Drag & Drop</small>
                     </div>
                   </div>
                   <input type="file" :ref="el => refs.logo_toko = el" @change="handleFileSelect($event, 'logo_toko')" accept="image/*" style="display: none;">
                 </div>

                 <!-- Foto KTP -->
                 <div class="mb-3">
                   <label class="form-label small text-muted mb-1">Foto KTP</label>
                   <div 
                     class="dropzone-compact" 
                     @click="triggerFileInput('foto_ktp')"
                     @dragover.prevent
                     @drop.prevent="handleDrop($event, 'foto_ktp')"
                   >
                     <div v-if="previews.foto_ktp" class="preview-img">
                       <img :src="previews.foto_ktp" alt="Preview">
                       <button type="button" class="btn-remove" @click.stop="removeImage('foto_ktp')">
                         <vue-feather type="x" style="width: 12px;"></vue-feather>
                       </button>
                     </div>
                     <div v-else class="dropzone-empty">
                       <vue-feather type="credit-card" class="text-muted" style="width: 24px;"></vue-feather>
                       <small class="text-muted mt-1">Klik atau Drag & Drop</small>
                     </div>
                   </div>
                   <input type="file" :ref="el => refs.foto_ktp = el" @change="handleFileSelect($event, 'foto_ktp')" accept="image/*" style="display: none;">
                 </div>

                 <!-- QR Code -->
                 <div class="mb-3">
                   <label class="form-label small text-muted mb-1">QR Code <span class="text-danger">*</span></label>
                   <div 
                     class="dropzone-compact dropzone-qr"
                     :class="{ 'scanning': isScanning }"
                     @click="triggerFileInput('qr_code')"
                     @dragover.prevent
                     @drop.prevent="handleDrop($event, 'qr_code')"
                   >
                     <div v-if="previews.qr_code" class="preview-img">
                       <img :src="previews.qr_code" alt="QR">
                       <button type="button" class="btn-remove" @click.stop="removeImage('qr_code')">
                         <vue-feather type="x" style="width: 12px;"></vue-feather>
                       </button>
                     </div>
                     <div v-else class="dropzone-empty">
                       <vue-feather type="grid" class="text-muted" :class="{ 'scanning-icon': isScanning }" style="width: 24px;"></vue-feather>
                       <small class="text-muted mt-1" v-if="!isScanning">Scan Otomatis</small>
                       <small class="text-primary mt-1 fw-bold" v-else>Memindai...</small>
                     </div>
                   </div>
                   <input type="file" :ref="el => refs.qr_code = el" @change="handleFileSelect($event, 'qr_code')" accept="image/*" style="display: none;">
                   <small class="text-muted">Auto-scan untuk isi barcode</small>
                 </div>

                 <!-- Kode Barcode -->
                 <div class="mb-0">
                   <label class="form-label small text-muted mb-1">Kode Barcode <span class="text-danger">*</span></label>
                   <input 
                     type="text" 
                     v-model="formData.kode_barcode" 
                     class="form-control form-control-sm" 
                     placeholder="Auto dari QR"
                     required
                     :readonly="previews.qr_code"
                   >
                   <small class="text-success" v-if="previews.qr_code">
                     <vue-feather type="check" style="width: 10px;"></vue-feather> Terisi otomatis
                   </small>
                 </div>
               </div>
             </div>
           </div>
         </div>

        </form>
     </div>
  </div>
</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { useDataStore } from "@/store/dataStore";
import memberService from '@/services/memberService';
import pendampingService from '@/services/pendampingService';
import Swal from 'sweetalert2';
import jsQR from 'jsqr'; // QR Code scanner library

export default {
  setup() {
    const router = useRouter();
    const isSubmitting = ref(false);
    const isScanning = ref(false);

    const formData = reactive({
      nama_member: '',
      nama_toko: '',
      nomor_handphone: '',
      alamat: '',
      latitude: '',
      longitude: '',
      koordinat: '',
      pendamping_id: '',
      kode_barcode: '',
      status: 'active'
    });

    const handleCoordinatePaste = () => {
      if (formData.koordinat) {
        const parts = formData.koordinat.split(',').map(p => p.trim());
        if (parts.length >= 2) {
          formData.latitude = parts[0];
          formData.longitude = parts[1];
        }
      } else {
        formData.latitude = '';
        formData.longitude = '';
      }
    };

    const files = reactive({
      foto_profil: null,
      foto_toko: null,
      logo_toko: null,
      foto_ktp: null,
      qr_code: null
    });

    const previews = reactive({
      foto_profil: null,
      foto_toko: null,
      logo_toko: null,
      foto_ktp: null,
      qr_code: null
    });

    const pendampingOptions = ref([]);

    // Define refs for file inputs
    const refs = {
      foto_profil: ref(null),
      foto_toko: ref(null),
      logo_toko: ref(null),
      foto_ktp: ref(null),
      qr_code: ref(null)
    };

    // Load initial data
    const loadOptions = async () => {
      try {
        const pendampingData = await pendampingService.getPendampings();
        pendampingOptions.value = (Array.isArray(pendampingData) ? pendampingData : pendampingData.items || [])
          .map(p => ({ id: p.id, text: p.nama_pendamping }));
      } catch (error) {
        console.error("Failed to load options", error);
      }
    };

    const triggerFileInput = (type) => {
      const ref = refs[type];
      if (ref) {
        ref.click();
      }
    };

    const handleFileSelect = async (event, type) => {
      const file = event.target.files[0];
      if (file) {
        await processFile(file, type);
      }
    };

    const handleDrop = async (event, type) => {
      const file = event.dataTransfer.files[0];
      if (file && file.type.startsWith('image/')) {
        await processFile(file, type);
      }
    };

    const processFile = async (file, type) => {
      files[type] = file;
      const reader = new FileReader();
      
      reader.onload = async (e) => {
        previews[type] = e.target.result;
        
        // If QR code, scan it
        if (type === 'qr_code') {
          await scanQRCode(e.target.result);
        }
      };
      
      reader.readAsDataURL(file);
    };

    const scanQRCode = async (imageSrc) => {
      isScanning.value = true;
      try {
        const image = new Image();
        image.src = imageSrc;
        
        await new Promise((resolve) => {
          image.onload = resolve;
        });

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = image.width;
        canvas.height = image.height;
        context.drawImage(image, 0, 0);

        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, imageData.width, imageData.height);

        if (code) {
          formData.kode_barcode = code.data;
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'QR Code berhasil dipindai!',
            showConfirmButton: false,
            timer: 2000
          });
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'QR Code tidak terdeteksi',
            text: 'Pastikan gambar QR Code jelas dan tidak buram',
          });
        }
      } catch (error) {
        console.error('QR Scan error:', error);
      } finally {
        isScanning.value = false;
      }
    };

    const removeImage = (type) => {
      files[type] = null;
      previews[type] = null;
      if (type === 'qr_code') {
        formData.kode_barcode = '';
      }
    };

    const { refreshData, setNewMemberId } = useDataStore();

    const submitForm = async () => {
      // Permission double check
      const userStr = localStorage.getItem('currentUser');
      const user = userStr ? JSON.parse(userStr) : null;
      const isAdmin = user?.role === 'admin';
      const perms = user?.permissions?.ssp?.members || [];
      
      if (!isAdmin && !perms.includes('create')) {
        Swal.fire('Akses Ditolak', 'Anda tidak memiliki izin untuk menambah data kios baru', 'error');
        return;
      }

      if (!formData.kode_barcode) {
        Swal.fire('Error', 'Kode Barcode wajib diisi. Upload QR Code atau isi manual.', 'error');
        return;
      }

      isSubmitting.value = true;
      
      try {
        const formDataToSend = new FormData();
        
        // Append text data
        Object.keys(formData).forEach(key => {
          if (formData[key]) {
            formDataToSend.append(key, formData[key]);
          }
        });

        // Append files
        Object.keys(files).forEach(key => {
          if (files[key]) {
            formDataToSend.append(key, files[key]);
          }
        });

        const response = await memberService.createMember(formDataToSend);
        const newMember = response.data;
        
        // Refresh global store data
        await refreshData('members');

        // Store the new member ID to highlight it
        if (newMember && newMember.id) {
          setNewMemberId(newMember.id);
        }

        const toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        });

        toast.fire({
          icon: 'success',
          title: 'Kios SSP berhasil didaftarkan'
        });

        router.push('/people/kios-list');
      } catch (error) {
        console.error('Submit error:', error);
        Swal.fire({
          icon: 'error',
          title: 'Gagal',
          text: error.response?.data?.detail || 'Terjadi kesalahan saat menyimpan data'
        });
      } finally {
        isSubmitting.value = false;
      }
    };

    const resetForm = () => {
      Object.keys(formData).forEach(key => {
        formData[key] = key === 'status' ? 'active' : '';
      });
      Object.keys(files).forEach(key => {
        files[key] = null;
        previews[key] = null;
      });
    };

    onMounted(loadOptions);

    return {
      formData,
      files,
      previews,
      pendampingOptions,
      isSubmitting,
      isScanning,
      refs,
      triggerFileInput,
      handleFileSelect,
      handleDrop,
      removeImage,
      handleCoordinatePaste,
      setNewMemberId,
      submitForm,
      resetForm,
      router
    };
  }
};
</script>

<style scoped>
/* Mobile Form Specific Styles */
.mob-add-member {
    background: #f8fafc;
    min-height: 100vh;
}

.mob-sticky-header-form {
    position: sticky;
    top: 0;
    z-index: 1000;
}

.btn-back-mob {
    width: 44px;
    height: 44px;
    border-radius: 14px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1e293b;
    border: 1px solid #f1f5f9;
    transition: all 0.2s;
}
.btn-back-mob:active {
    transform: scale(0.9);
    background: #f8fafc;
}

.mob-form-card {
    border: 1px solid rgba(0,0,0,0.03);
}

.section-icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.mob-label {
    font-size: 11px;
    font-weight: 800;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
    display: block;
}

.mob-input {
    width: 100%;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px 14px;
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
    transition: all 0.2s;
}

.mob-input:focus {
    background: white;
    border-color: #029147;
    box-shadow: 0 0 0 4px rgba(2, 145, 71, 0.08);
    outline: none;
}

.mob-input-icon {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
}

.mob-upload-box {
    width: 100%;
    aspect-ratio: 1/1;
    background: #f8fafc;
    border: 2px dashed #e2e8f0;
    border-radius: 16px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.mob-upload-box-wide {
    width: 100%;
    height: 80px;
    background: #f8fafc;
    border: 2px dashed #e2e8f0;
    border-radius: 16px;
    position: relative;
    overflow: hidden;
}

.upload-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.upload-placeholder-wide {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.preview-full {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.mob-btn-remove {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: rgba(220, 38, 38, 0.9);
    color: white;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(4px);
}

.mob-sticky-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
}

.border-dashed { border-style: dashed !important; }

/* Desktop styles maintained */
.dropzone-compact {
  border: 1.5px dashed #dee2e6;
  border-radius: 6px;
  padding: 12px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fafafa;
  min-height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dropzone-compact:hover {
  border-color: #0d6efd;
  background: #f0f7ff;
}
.dropzone-qr.scanning {
  border-color: #0dcaf0;
  background: #e7f8fc;
}

.preview-img {
  position: relative;
  width: 100%;
}
.preview-img img {
  width: 100%;
  height: 90px;
  object-fit: cover;
  border-radius: 6px;
}

.scanning-icon {
  animation: pulse 1s infinite;
}
.mob-pulse {
  animation: pulse 1s infinite;
}
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

.fw-800 { font-weight: 800 !important; }
.uppercase { text-transform: uppercase; }
.tracking-wider { letter-spacing: 0.05em; }

.bg-success-soft { background-color: rgba(2, 145, 71, 0.1); }
.bg-blue-soft { background-color: rgba(37, 99, 235, 0.1); }
.bg-purple-soft { background-color: rgba(147, 51, 234, 0.1); }
.bg-light-soft { background-color: #f1f5f9; }
</style>
